<template>
  <v-layout pa-2 mt-2>
    <v-flex>
      <v-card>
        <v-card-title>
          <i class="material-icons light-blue--text">date_range</i>
          <div class="headline">&nbsp;Partnership program:</div>
          <div class="subheader pt-2" :style="{'flex': '0 0 100%'}">By using this partner link you can invite two users each month. First referral user gives 20% commision, second is 60%, another users won't give anything. Resets each month (at 1st day of month). The referrals will get 10% discount.</div>
        </v-card-title>
          <v-layout row wrap >
            <v-flex xs12 sm12 md12 lg8 pa-2 mb-2 >
              <GetPartnerLinkModal></GetPartnerLinkModal>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                class="white--text"
                @click="affiliatePaymentsDialog = true;"
              >
                <v-icon class="pr-2">history</v-icon>
                Affiliate payments
              </v-btn>
            </v-flex>
          </v-layout>
      </v-card>
    </v-flex>
    <AffiliatePaymentsModal v-if="affiliatePaymentsDialog" :affiliatePaymentsDialog="affiliatePaymentsDialog"></AffiliatePaymentsModal>
  </v-layout>
</template>

<script>
export default {
  name: 'AccountPartners',
  data () {
    return {
      loading: false,
      affiliatePaymentsDialog: false
    }
  },
  mounted () {
    this.$on('affiliatePaymentsDialog', (value) => {
      this.affiliatePaymentsDialog = value
    })
  },
  beforeDestroy () {
    this.$off('affiliatePaymentsDialog')
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/AccountPartners.vue